var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Download, Search } from '@mui/icons-material';
import { Chip, Stack, Typography, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerCardEditIcon, DropDownIconNew, PlusHeaderIcon } from '../../../assets/customIcons';
import { ArrowUPIcon } from '../../../assets/images';
import { ReactComponent as LeftArrow } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as CheckSVGIcon } from '../../../assets/images/check-circle.svg';
import { ReactComponent as VerifiedIcon } from '../../../assets/images/check-verified.svg';
import { ReactComponent as RightArrow } from '../../../assets/images/chevron-right.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/close.svg';
import { ReactComponent as LinkSvg } from '../../../assets/images/linkIcon.svg';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { ReactComponent as NoDocumenetsIcon } from '../../../assets/images/NoDocuments.svg';
import { ReactComponent as ShareIcon } from '../../../assets/images/shearIcon.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { getByIdAPI, getListAPI } from '../../../redux/crudSlice';
import { useAppDispatch } from '../../../store/hooks';
import { getStatusColor } from '../../../theme/statusColors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate } from '../../../utils/utils';
import { executiveListAPI, getCustomerDetailsAPI, InstallBaseListAPI, searchByMobileNoAPI } from '../../contractSaleInvoice/services/apiCall';
import { PrintIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import ContractDetailsDrawer from '../components/contractDetailsDrawer';
import { CSODiscard } from '../components/discard';
import { OrderSummaryPopup } from '../components/orderSummaryPopup';
import { CSOSaveSuccessfullPopUp } from '../components/saveSuccessfullPopUp';
import { contractSaleOrderInstallBaseDetails, GetContractSaleOrder, UpsertContractSaleOrderAPI } from '../services/apiCall';
import { ActiveContractsURL, ContractSaleOrderKeys, NewContractsURL, UsertContractSaleOrderURL } from '../services/entity';
import { showLoader } from '../../../redux/commonSlice';
import { VehicleHistory } from '../../vehicleHistory/pages/vehicleHistory';
var NewContractSaleOrder = function () {
    var _getLocalStorageItem;
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var User = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches[0];
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var id = useParams().id;
    var getInstallbase = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var _res5, _res6, res, customer, _res, _res2, customerDetails, _customerData$Person, _customerData$Person2, _customerData$PersonC, _customerData$PersonC2, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, customerData, _MobileRes$data, _res3, MobileRes, _MobileRes$data$, _res4, customerDetails, _customerData$Person3, _customerData$Person4, _customerData$PersonC3, _customerData$PersonC4, _customerData$Address5, _customerData$Address6, _customerData$Address7, _customerData$Address8, customerData, existingInstallbase, _res7, _res8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(((state === null || state === void 0 ? void 0 : state.Key) === "VinNo" || (state === null || state === void 0 ? void 0 : state.Key) === "RegistrationNo") && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 8];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, contractSaleOrderInstallBaseDetails({
                            request: {
                                Key: state === null || state === void 0 ? void 0 : state.Key,
                                Value: state === null || state === void 0 ? void 0 : state.Value
                            }
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (!((_res = res) !== null && _res !== void 0 && (_res = _res.data) !== null && _res !== void 0 && (_res = _res.Customer) !== null && _res !== void 0 && _res.CustomerId)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: (_res2 = res) === null || _res2 === void 0 || (_res2 = _res2.data) === null || _res2 === void 0 || (_res2 = _res2.Customer) === null || _res2 === void 0 ? void 0 : _res2.CustomerId
                            }
                        })];
                case 5:
                    customerDetails = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    if (customerDetails !== null && customerDetails !== void 0 && customerDetails.success) {
                        customerData = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.data;
                        customer = {
                            PersonName: "".concat((customerData === null || customerData === void 0 || (_customerData$Person = customerData.Person) === null || _customerData$Person === void 0 ? void 0 : _customerData$Person.GivenName) || '', " ").concat((customerData === null || customerData === void 0 || (_customerData$Person2 = customerData.Person) === null || _customerData$Person2 === void 0 ? void 0 : _customerData$Person2.FamilyName) || '').trim(),
                            PrimaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContact) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; })) || null,
                            SecondaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC2 = customerData.PersonContact) === null || _customerData$PersonC2 === void 0 ? void 0 : _customerData$PersonC2.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Secondary"; })) || null,
                            Address: [customerData === null || customerData === void 0 || (_customerData$Address = customerData.Address) === null || _customerData$Address === void 0 || (_customerData$Address = _customerData$Address[0]) === null || _customerData$Address === void 0 ? void 0 : _customerData$Address.Address1, customerData === null || customerData === void 0 || (_customerData$Address2 = customerData.Address) === null || _customerData$Address2 === void 0 || (_customerData$Address2 = _customerData$Address2[0]) === null || _customerData$Address2 === void 0 ? void 0 : _customerData$Address2.Address2, customerData === null || customerData === void 0 || (_customerData$Address3 = customerData.Address) === null || _customerData$Address3 === void 0 || (_customerData$Address3 = _customerData$Address3[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address3, customerData === null || customerData === void 0 || (_customerData$Address4 = customerData.Address) === null || _customerData$Address4 === void 0 || (_customerData$Address4 = _customerData$Address4[0]) === null || _customerData$Address4 === void 0 ? void 0 : _customerData$Address4.Address4].filter(Boolean).join(', ')
                        };
                    }
                    _a.label = 7;
                case 7: return [3 /*break*/, 17];
                case 8:
                    if (!(((state === null || state === void 0 ? void 0 : state.Key) === "Mobile" || (state === null || state === void 0 ? void 0 : state.Key) === "Email") && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 17];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 9:
                    _a.sent();
                    return [4 /*yield*/, searchByMobileNoAPI({
                            request: {
                                MobileNumber: state === null || state === void 0 ? void 0 : state.Value
                            }
                        })];
                case 10:
                    MobileRes = _a.sent();
                    if (!(MobileRes.statusCode == 200 && MobileRes.success && (MobileRes === null || MobileRes === void 0 || (_MobileRes$data = MobileRes.data) === null || _MobileRes$data === void 0 ? void 0 : _MobileRes$data.length) > 0)) return [3 /*break*/, 12];
                    return [4 /*yield*/, InstallBaseListAPI({
                            request: {
                                Value: MobileRes === null || MobileRes === void 0 || (_MobileRes$data$ = MobileRes.data[0]) === null || _MobileRes$data$ === void 0 ? void 0 : _MobileRes$data$.PersonId,
                                Key: 'PersonId'
                            }
                        })];
                case 11:
                    res = _a.sent();
                    _a.label = 12;
                case 12: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 13:
                    _a.sent();
                    if (!((_res3 = res) !== null && _res3 !== void 0 && (_res3 = _res3.data) !== null && _res3 !== void 0 && (_res3 = _res3.Customer) !== null && _res3 !== void 0 && _res3.CustomerId)) return [3 /*break*/, 17];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 14:
                    _a.sent();
                    return [4 /*yield*/, getCustomerDetailsAPI({
                            request: {
                                id: (_res4 = res) === null || _res4 === void 0 || (_res4 = _res4.data) === null || _res4 === void 0 || (_res4 = _res4.Customer) === null || _res4 === void 0 ? void 0 : _res4.CustomerId
                            }
                        })];
                case 15:
                    customerDetails = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 16:
                    _a.sent();
                    if (customerDetails !== null && customerDetails !== void 0 && customerDetails.success) {
                        customerData = customerDetails === null || customerDetails === void 0 ? void 0 : customerDetails.data;
                        customer = {
                            PersonName: "".concat((customerData === null || customerData === void 0 || (_customerData$Person3 = customerData.Person) === null || _customerData$Person3 === void 0 ? void 0 : _customerData$Person3.GivenName) || '', " ").concat((customerData === null || customerData === void 0 || (_customerData$Person4 = customerData.Person) === null || _customerData$Person4 === void 0 ? void 0 : _customerData$Person4.FamilyName) || '').trim(),
                            PrimaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC3 = customerData.PersonContact) === null || _customerData$PersonC3 === void 0 ? void 0 : _customerData$PersonC3.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; })) || null,
                            SecondaryContact: (customerData === null || customerData === void 0 || (_customerData$PersonC4 = customerData.PersonContact) === null || _customerData$PersonC4 === void 0 ? void 0 : _customerData$PersonC4.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Secondary"; })) || null,
                            Address: [customerData === null || customerData === void 0 || (_customerData$Address5 = customerData.Address) === null || _customerData$Address5 === void 0 || (_customerData$Address5 = _customerData$Address5[0]) === null || _customerData$Address5 === void 0 ? void 0 : _customerData$Address5.Address1, customerData === null || customerData === void 0 || (_customerData$Address6 = customerData.Address) === null || _customerData$Address6 === void 0 || (_customerData$Address6 = _customerData$Address6[0]) === null || _customerData$Address6 === void 0 ? void 0 : _customerData$Address6.Address2, customerData === null || customerData === void 0 || (_customerData$Address7 = customerData.Address) === null || _customerData$Address7 === void 0 || (_customerData$Address7 = _customerData$Address7[0]) === null || _customerData$Address7 === void 0 ? void 0 : _customerData$Address7.Address3, customerData === null || customerData === void 0 || (_customerData$Address8 = customerData.Address) === null || _customerData$Address8 === void 0 || (_customerData$Address8 = _customerData$Address8[0]) === null || _customerData$Address8 === void 0 ? void 0 : _customerData$Address8.Address4].filter(Boolean).join(', ')
                        };
                    }
                    _a.label = 17;
                case 17:
                    existingInstallbase = ((_res5 = res) === null || _res5 === void 0 || (_res5 = _res5.data) === null || _res5 === void 0 ? void 0 : _res5.InstallBase) || [];
                    if (!((_res6 = res) !== null && _res6 !== void 0 && _res6.success)) return [3 /*break*/, 19];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 18:
                    _a.sent();
                    return [2 /*return*/, _objectSpread(_objectSpread({}, (_res7 = res) === null || _res7 === void 0 ? void 0 : _res7.data), {}, {
                            InstallBase: existingInstallbase,
                            success: (_res8 = res) === null || _res8 === void 0 ? void 0 : _res8.success,
                            resultnotfound: false
                        }, customer)];
                case 19: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 20:
                    _a.sent();
                    return [2 /*return*/, {
                            resultnotfound: true
                        }];
            }
        });
    }); };
    var searchType = [{
            id: 'RegistrationNo',
            label: 'Reg. No'
        }, {
            id: 'VinNo',
            label: 'Vin. No'
        }, {
            id: 'Mobile',
            label: 'Mobile'
        }
        // { id: 'Email', label: 'Email' },
    ];
    var generalFields = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                overflow: 'scroll'
            },
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 0,
                    display: 'flex',
                    bgcolor: 'white',
                    padding: '8px',
                    gap: '20px',
                    alignItems: 'center',
                    borderRadius: '8px',
                    setFieldProps: function (state) {
                        var _ref;
                        return {
                            type: FormItemTypes.Box,
                            name: '',
                            elements: (_ref = id ? state === null || state === void 0 ? void 0 : state.VehicleContractDetails : state === null || state === void 0 ? void 0 : state.InstallBase) === null || _ref === void 0 ? void 0 : _ref.map(function (data, index) {
                                var _state$VehicleContrac, _state$VehicleContrac2;
                                return {
                                    type: FormItemTypes.Box,
                                    name: 'vehicleNumber',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    columnSize: 0,
                                    borderRadius: '8px',
                                    padding: '6px 12px',
                                    setFieldProps: function (state, value) {
                                        return {
                                            type: FormItemTypes.Box,
                                            bgcolor: (state === null || state === void 0 ? void 0 : state.selectedVehicle) === (data === null || data === void 0 ? void 0 : data.RegistrationNo) ? 'secondary.100' : 'transparent'
                                        };
                                    },
                                    elements: [{
                                            type: FormItemTypes.CheckBox,
                                            label: '',
                                            name: "vehicle-".concat(data === null || data === void 0 ? void 0 : data.InstallBaseId),
                                            columnSize: 0,
                                            sx: {
                                                padding: 0
                                            },
                                            formControlLabelProps: {
                                                sx: {
                                                    margin: 0
                                                }
                                            },
                                            setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                var updatedDetails;
                                                return __generator(this, function (_a) {
                                                    updatedDetails = __spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails) || []), true);
                                                    if (currValue) {
                                                        updatedDetails.push({
                                                            VinNo: data === null || data === void 0 ? void 0 : data.VinNo,
                                                            RegistrationNo: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                            InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId,
                                                            id: data === null || data === void 0 ? void 0 : data.InstallBaseId,
                                                            EngineNo: data === null || data === void 0 ? void 0 : data.EngineNo,
                                                            ModelName: data === null || data === void 0 ? void 0 : data.ModelName,
                                                            SalesInvoiceDate: data === null || data === void 0 ? void 0 : data.SalesInvoiceDate,
                                                            ProductName: data === null || data === void 0 ? void 0 : data.ProductName,
                                                            ProductCode: id ? data === null || data === void 0 ? void 0 : data.ProductCode : data === null || data === void 0 ? void 0 : data.SKUCode,
                                                            isSelected: true
                                                        });
                                                    }
                                                    else {
                                                        updatedDetails = updatedDetails.filter(function (item) { return item.InstallBaseId !== data.InstallBaseId; });
                                                    }
                                                    return [2 /*return*/, {
                                                            VehicleContractDetails: updatedDetails
                                                        }];
                                                });
                                            }); },
                                            valueGetter: function (formValues) {
                                                return ((formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails) || []).some(function (item) { return (item === null || item === void 0 ? void 0 : item.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); });
                                            }
                                        }, {
                                            type: FormItemTypes.Button,
                                            name: '',
                                            variant: 'text',
                                            children: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                            color: 'info',
                                            columnSize: 0,
                                            sx: {
                                                p: 0,
                                                gap: '20px',
                                                color: 'secondary.900'
                                            },
                                            disabled: !((state === null || state === void 0 ? void 0 : state.VehicleContractDetails) || []).some(function (item) { return (item === null || item === void 0 ? void 0 : item.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); }),
                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                var _res$payload, _newContractRes$paylo, res, newContractRes, updatedActiveContracts, updatedNewContracts;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, dispatch(showLoader({
                                                                isLoaderOpen: true
                                                            }))];
                                                        case 1:
                                                            _a.sent();
                                                            return [4 /*yield*/, dispatch(getListAPI({
                                                                    key: ContractSaleOrderKeys.ActiveContracts,
                                                                    url: ActiveContractsURL,
                                                                    request: {
                                                                        InstallBaseId: data === null || data === void 0 ? void 0 : data.InstallBaseId
                                                                    }
                                                                }))];
                                                        case 2:
                                                            res = _a.sent();
                                                            return [4 /*yield*/, dispatch(getByIdAPI({
                                                                    key: ContractSaleOrderKeys.NewContracts,
                                                                    url: NewContractsURL,
                                                                    request: {}
                                                                }))];
                                                        case 3:
                                                            newContractRes = _a.sent();
                                                            updatedActiveContracts = (res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 || (_res$payload = _res$payload.data) === null || _res$payload === void 0 ? void 0 : _res$payload.map(function (contract) {
                                                                var _contract$ContractPri, _contract$Price, _contract$ContractPri2, _contract$ContractPri3, _formValues$InstallBa;
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    ContractPrice: (_contract$ContractPri = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri !== void 0 ? _contract$ContractPri : 0,
                                                                    Rate: (_contract$Price = contract === null || contract === void 0 ? void 0 : contract.Price) !== null && _contract$Price !== void 0 ? _contract$Price : 0,
                                                                    DiscountPercentage: 0,
                                                                    DiscountAmount: 0,
                                                                    ChargesAmount: 0,
                                                                    TaxableAmount: (_contract$ContractPri2 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri2 !== void 0 ? _contract$ContractPri2 : 0,
                                                                    UnitOfMeasurementId: null,
                                                                    PostingTypeId: null,
                                                                    TotalAmount: (_contract$ContractPri3 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri3 !== void 0 ? _contract$ContractPri3 : 0,
                                                                    Quantity: 1,
                                                                    SGST_UTGST_Percentage: 0,
                                                                    SGST_UTGST_Amount: 0,
                                                                    CGSTAmount: 0,
                                                                    CGSTPercentage: 0,
                                                                    IGSTAmount: 0,
                                                                    IGSTPercentage: 0,
                                                                    EntityId: id ? contract === null || contract === void 0 ? void 0 : contract.EntityId : formValues === null || formValues === void 0 || (_formValues$InstallBa = formValues.InstallBase[0]) === null || _formValues$InstallBa === void 0 ? void 0 : _formValues$InstallBa.SchemaId,
                                                                    ChildId: id ? contract === null || contract === void 0 ? void 0 : contract.ChildId : contract === null || contract === void 0 ? void 0 : contract.id
                                                                });
                                                            })) || [];
                                                            updatedNewContracts = (newContractRes === null || newContractRes === void 0 || (_newContractRes$paylo = newContractRes.payload) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.value) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.data) === null || _newContractRes$paylo === void 0 ? void 0 : _newContractRes$paylo.map(function (contract) {
                                                                var _contract$ContractPri4, _contract$ContractPri5, _contract$ContractPri6, _contract$ContractPri7;
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    ContractPrice: (_contract$ContractPri4 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri4 !== void 0 ? _contract$ContractPri4 : 0,
                                                                    Rate: (_contract$ContractPri5 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri5 !== void 0 ? _contract$ContractPri5 : 0,
                                                                    DiscountPercentage: 0,
                                                                    DiscountAmount: 0,
                                                                    ChargesAmount: 0,
                                                                    TaxableAmount: (_contract$ContractPri6 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri6 !== void 0 ? _contract$ContractPri6 : 0,
                                                                    UnitOfMeasurementId: null,
                                                                    PostingTypeId: null,
                                                                    TotalAmount: (_contract$ContractPri7 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri7 !== void 0 ? _contract$ContractPri7 : 0,
                                                                    Quantity: 1,
                                                                    SGST_UTGST_Percentage: 0,
                                                                    SGST_UTGST_Amount: 0,
                                                                    CGSTAmount: 0,
                                                                    CGSTPercentage: 0,
                                                                    IGSTAmount: 0,
                                                                    IGSTPercentage: 0,
                                                                    SystemName: 'ServiceContract',
                                                                    ChildId: contract === null || contract === void 0 ? void 0 : contract.id
                                                                });
                                                            })) || [];
                                                            return [4 /*yield*/, dispatch(showLoader({
                                                                    isLoaderOpen: false
                                                                }))];
                                                        case 4:
                                                            _a.sent();
                                                            return [2 /*return*/, {
                                                                    selectedVehicle: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                                    ActiveContracts: updatedActiveContracts,
                                                                    NewContracts: updatedNewContracts,
                                                                    SelectedButton: 'New',
                                                                    EngineNo: data === null || data === void 0 ? void 0 : data.EngineNo,
                                                                    VinNo: data === null || data === void 0 ? void 0 : data.VinNo,
                                                                    RegistrationNo: data === null || data === void 0 ? void 0 : data.RegistrationNo,
                                                                    ModelName: data === null || data === void 0 ? void 0 : data.ModelName,
                                                                    SalesInvoiceDate: data === null || data === void 0 ? void 0 : data.SalesInvoiceDate,
                                                                    ProductName: data === null || data === void 0 ? void 0 : data.ProductName,
                                                                    ProductCode: id ? data === null || data === void 0 ? void 0 : data.ProductCode : data === null || data === void 0 ? void 0 : data.SKUCode
                                                                }];
                                                    }
                                                });
                                            }); },
                                            endIcon: /*#__PURE__*/ React.createElement(Stack, null, (state === null || state === void 0 || (_state$VehicleContrac = state.VehicleContractDetails) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac === void 0 || (_state$VehicleContrac = _state$VehicleContrac.Items) === null || _state$VehicleContrac === void 0 ? void 0 : _state$VehicleContrac.length) > 0 && /*#__PURE__*/ React.createElement(Chip, {
                                                color: "secondary",
                                                label: (state === null || state === void 0 || (_state$VehicleContrac2 = state.VehicleContractDetails) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (data === null || data === void 0 ? void 0 : data.RegistrationNo); })) === null || _state$VehicleContrac2 === void 0 || (_state$VehicleContrac2 = _state$VehicleContrac2.Items) === null || _state$VehicleContrac2 === void 0 ? void 0 : _state$VehicleContrac2.length) || 0
                                            }))
                                        }]
                                };
                            })
                        };
                    }
                }],
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: id ? state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none' : undefined
                }
            }); }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    sx: {
                        border: '1px',
                        borderRadius: "12px",
                        borderColor: "secondary.200"
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: true,
                            fontWeight: "strong",
                            children: 'Basic details',
                            color: "secondary.900"
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            columnSize: 0,
                            children: isOpen ? /*#__PURE__*/ React.createElement("img", {
                                src: ArrowUPIcon,
                                alt: ""
                            }) : /*#__PURE__*/ React.createElement(DropDownIconNew, {
                                sx: {
                                    color: 'secondary.500'
                                }
                            }),
                            setFormState: function (formValues, currValue) {
                                if (isOpen) {
                                    setIsOpen(false);
                                }
                                else {
                                    setIsOpen(true);
                                }
                                return {};
                            }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1,
                            columnSpacing: 2,
                            alignItems: 'start',
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    spacing: 0,
                                    rowGap: 1,
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            children: 'Customer details',
                                            fontSize: 'sm',
                                            fontWeight: 'medium',
                                            color: 'text.secondary',
                                            columnSize: 12
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            sx: {
                                                p: 1.5
                                            },
                                            columnSize: 12,
                                            contentProps: {
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    columnGap: 1,
                                                    alignItems: 'center',
                                                    flexWrap: 'nowrap',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0,
                                                            sx: {
                                                                height: 24,
                                                                width: 24
                                                            }
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'PersonName',
                                                            columnSize: 0,
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'SMobileNumber',
                                                            columnSize: true,
                                                            fontSize: "sm",
                                                            color: 'text.secondary',
                                                            valueGetter: function (formValues, field) {
                                                                var _formValues$PrimaryCo;
                                                                return formValues === null || formValues === void 0 || (_formValues$PrimaryCo = formValues.PrimaryContact) === null || _formValues$PrimaryCo === void 0 ? void 0 : _formValues$PrimaryCo.MobileNumber;
                                                            }
                                                        }, {
                                                            type: FormItemTypes.IconButton,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                color: "secondary"
                                                            }),
                                                            columnSize: 0,
                                                            color: 'secondary'
                                                            // onClick:async()=>{
                                                            //   const res = await dispatch(showSurface({
                                                            //     type: 'Dialog',
                                                            //     Component: EditCustomerdetails,
                                                            //     containerProps: {
                                                            //       PaperProps: { sx: { borderRadius: '8px' } }
                                                            //     }
                                                            //   }));
                                                            // }
                                                        }]
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            sx: {
                                                p: '12px'
                                            },
                                            contentProps: {
                                                spacing: 0,
                                                rowSpacing: '12px'
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    gap: '8px',
                                                    justifyContent: 'space-between',
                                                    elements: [{
                                                            type: FormItemTypes.Avatar,
                                                            name: '',
                                                            columnSize: 0
                                                        }, {
                                                            type: FormItemTypes.ContainerItem,
                                                            name: '',
                                                            columnSize: 8.5,
                                                            spacing: 0,
                                                            gap: '4px',
                                                            elements: [{
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'PersonName',
                                                                    columnSize: 12,
                                                                    fontWeight: 'medium'
                                                                }, {
                                                                    type: FormItemTypes.ContainerItem,
                                                                    name: '',
                                                                    columnSize: 12,
                                                                    spacing: 0,
                                                                    gap: '4px',
                                                                    elements: [{
                                                                            type: FormItemTypes.Typography,
                                                                            name: 'PMobileNumber',
                                                                            containerProps: {
                                                                                spacing: 0
                                                                            },
                                                                            columnSize: 0,
                                                                            color: 'secondary.500',
                                                                            fontSize: 'sm',
                                                                            valueGetter: function (formValues, field) {
                                                                                var _formValues$PrimaryCo2;
                                                                                return formValues === null || formValues === void 0 || (_formValues$PrimaryCo2 = formValues.PrimaryContact) === null || _formValues$PrimaryCo2 === void 0 ? void 0 : _formValues$PrimaryCo2.MobileNumber;
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(VerifiedIcon, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: 'info.500',
                                                                                p: 0,
                                                                                pb: '6px'
                                                                            },
                                                                            setFieldProps: function (formValues) {
                                                                                var _formValues$PrimaryCo3;
                                                                                return {
                                                                                    type: FormItemTypes.Icon,
                                                                                    sx: {
                                                                                        display: formValues !== null && formValues !== void 0 && (_formValues$PrimaryCo3 = formValues.PrimaryContact) !== null && _formValues$PrimaryCo3 !== void 0 && _formValues$PrimaryCo3.IsMobileVerified ? 'inline-flex' : 'none',
                                                                                        color: 'info.500',
                                                                                        p: 0,
                                                                                        pb: '6px'
                                                                                    }
                                                                                };
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Divider,
                                                                            name: 'name',
                                                                            variant: 'fullWidth',
                                                                            orientation: 'vertical',
                                                                            columnSize: 0,
                                                                            setFieldProps: function (formValues) {
                                                                                var _formValues$Secondary;
                                                                                return {
                                                                                    type: FormItemTypes.Divider,
                                                                                    sx: {
                                                                                        display: formValues !== null && formValues !== void 0 && (_formValues$Secondary = formValues.SecondaryContact) !== null && _formValues$Secondary !== void 0 && _formValues$Secondary.MobileNumber ? 'inline-flex' : 'none'
                                                                                    }
                                                                                };
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.Typography,
                                                                            name: 'SMobileNumber',
                                                                            containerProps: {
                                                                                spacing: 0
                                                                            },
                                                                            columnSize: 0,
                                                                            color: 'secondary.500',
                                                                            fontSize: 'sm',
                                                                            valueGetter: function (formValues) {
                                                                                var _formValues$Secondary2;
                                                                                return formValues === null || formValues === void 0 || (_formValues$Secondary2 = formValues.SecondaryContact) === null || _formValues$Secondary2 === void 0 ? void 0 : _formValues$Secondary2.MobileNumber;
                                                                            }
                                                                        }, {
                                                                            type: FormItemTypes.IconButton,
                                                                            name: '',
                                                                            children: /*#__PURE__*/ React.createElement(VerifiedIcon, null),
                                                                            columnSize: 0,
                                                                            sx: {
                                                                                color: 'info.500',
                                                                                p: 0,
                                                                                pb: '6px'
                                                                            },
                                                                            setFieldProps: function (formValues) {
                                                                                var _formValues$Secondary3;
                                                                                return {
                                                                                    type: FormItemTypes.Icon,
                                                                                    sx: {
                                                                                        display: formValues !== null && formValues !== void 0 && (_formValues$Secondary3 = formValues.SecondaryContact) !== null && _formValues$Secondary3 !== void 0 && _formValues$Secondary3.IsMobileVerified ? 'inline-flex' : 'none',
                                                                                        color: 'info.500',
                                                                                        p: 0,
                                                                                        pb: '6px'
                                                                                    }
                                                                                };
                                                                            }
                                                                        }]
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Icon,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, {
                                                                color: "secondary"
                                                            }),
                                                            columnSize: 0,
                                                            sx: {
                                                                cursor: 'pointer',
                                                                height: '20px',
                                                                width: '20px'
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    gap: '8px',
                                                    elements: [{
                                                            type: FormItemTypes.ContainerItem,
                                                            name: 'customer-email',
                                                            columnSize: 12,
                                                            spacing: 0,
                                                            columnGap: 1,
                                                            elements: [{
                                                                    type: FormItemTypes.Custom,
                                                                    name: '',
                                                                    value: null,
                                                                    columnSize: 0,
                                                                    element: function () { /*#__PURE__*/ return React.createElement(MailIcon, {
                                                                        color: 'secondary.500',
                                                                        width: 16,
                                                                        height: 16
                                                                    }); },
                                                                    containerProps: {
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center'
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Email',
                                                                    columnSize: true,
                                                                    color: 'secondary',
                                                                    valueGetter: function (formValues) {
                                                                        var _formValues$PrimaryCo4, _formValues$PrimaryCo5;
                                                                        return (_formValues$PrimaryCo4 = formValues === null || formValues === void 0 || (_formValues$PrimaryCo5 = formValues.PrimaryContact) === null || _formValues$PrimaryCo5 === void 0 ? void 0 : _formValues$PrimaryCo5.Email) !== null && _formValues$PrimaryCo4 !== void 0 ? _formValues$PrimaryCo4 : '-';
                                                                    }
                                                                }]
                                                        }, {
                                                            type: FormItemTypes.Box,
                                                            name: '',
                                                            display: 'flex',
                                                            columnSize: 12,
                                                            gap: '8px',
                                                            alignItems: 'start',
                                                            elements: [{
                                                                    type: FormItemTypes.IconButton,
                                                                    name: '',
                                                                    children: /*#__PURE__*/ React.createElement(LocationIcon, {
                                                                        height: 16,
                                                                        width: 16
                                                                    }),
                                                                    columnSize: 0,
                                                                    sx: {
                                                                        paddingInline: 0
                                                                    }
                                                                }, {
                                                                    type: FormItemTypes.Typography,
                                                                    name: 'Address',
                                                                    columnSize: true,
                                                                    color: "secondary.500",
                                                                    fontSize: 'sm',
                                                                    fontWeight: 'normal'
                                                                }]
                                                        }]
                                                }]
                                        } : null]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 4,
                                    spacing: 0,
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: 'BasicDetails',
                                            justifyContent: 'space-between',
                                            spacing: 0,
                                            alignItems: 'center',
                                            mt: '-12px',
                                            columnSize: 12,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    children: 'Vehicle details',
                                                    fontSize: 'sm',
                                                    fontWeight: 'medium',
                                                    color: 'text.secondary',
                                                    columnSize: 0,
                                                    containerProps: {
                                                        spacing: 0,
                                                        m: 0
                                                    }
                                                }, {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    children: 'Vehicle history',
                                                    size: 'small',
                                                    columnSize: 0,
                                                    onClick: function (e, formValue) {
                                                        var vehicleHistoryDrawer = dispatch(showSurface({
                                                            type: 'Drawer',
                                                            Component: VehicleHistory,
                                                            containerProps: {
                                                                PaperProps: {
                                                                    sx: {
                                                                        width: IS_MOBILE ? '100%' : '60%',
                                                                        borderRadius: IS_MOBILE ? '8px 8px 0 0' : null
                                                                    }
                                                                },
                                                                anchor: IS_MOBILE ? 'bottom' : 'right'
                                                            },
                                                            componentProps: {
                                                                selectedVinNo: formValue === null || formValue === void 0 ? void 0 : formValue.VinNo,
                                                                isRightDrawer: true
                                                            }
                                                        }));
                                                    }
                                                }]
                                        }, !isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            contentProps: {
                                                justifyContent: "space-between",
                                                spacing: 0
                                            },
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'RegistrationNo',
                                                    columnSize: 0,
                                                    fontWeight: 'medium'
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    columnSize: 0,
                                                    fontSize: "sm",
                                                    color: 'text.secondary',
                                                    valueGetter: function (formValues, field) {
                                                        return "".concat(formValues === null || formValues === void 0 ? void 0 : formValues.ProductName, " ( ").concat(formValues === null || formValues === void 0 ? void 0 : formValues.ProductCode, " )");
                                                    }
                                                }]
                                        } : null, isOpen ? {
                                            type: FormItemTypes.CardComponent,
                                            name: '',
                                            columnSize: 12,
                                            sx: {
                                                p: '12px'
                                            },
                                            contentProps: {
                                                spacing: 0,
                                                rowGap: 0.5
                                            },
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: 12,
                                                    spacing: 0,
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'RegistrationNo',
                                                            columnSize: 12,
                                                            fontWeight: 'medium'
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            columnSize: 12,
                                                            fontSize: "sm",
                                                            color: 'text.secondary',
                                                            valueGetter: function (formValues, field) {
                                                                return "".concat(formValues === null || formValues === void 0 ? void 0 : formValues.ProductName, " ( ").concat(formValues === null || formValues === void 0 ? void 0 : formValues.ProductCode, " )");
                                                            }
                                                        }]
                                                }, {
                                                    type: FormItemTypes.CardComponent,
                                                    name: 'Vehicle details',
                                                    containerProps: {
                                                        spacing: 0
                                                    },
                                                    columnSize: 12,
                                                    sx: {
                                                        bgcolor: "secondary.50",
                                                        border: "none",
                                                        px: 1.5,
                                                        py: 1
                                                    },
                                                    contentProps: {
                                                        spacing: 0
                                                    },
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'RegistrationNo',
                                                            label: 'Registration no:',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'ProductName',
                                                            label: 'Model',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'EngineNo',
                                                            label: 'Engine no:',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'VinNo',
                                                            label: 'Chassis no.:',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12
                                                        }, {
                                                            type: FormItemTypes.Typography,
                                                            name: 'SalesInvoiceDate',
                                                            label: 'Date of sale:',
                                                            containerProps: {
                                                                display: 'inline-flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'baseline',
                                                                gap: 1
                                                            },
                                                            labelTypographyProps: {
                                                                mb: 0,
                                                                noWrap: true,
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm'
                                                            },
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm',
                                                            columnSize: 12,
                                                            valueGetter: function (formValues, field) {
                                                                return formValues !== null && formValues !== void 0 && formValues.SalesInvoiceDate ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.SalesInvoiceDate).format("DD MMM, YYYY") : '-';
                                                            }
                                                        }]
                                                }]
                                        } : null]
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            label: 'Order details',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'ApprovedById',
                    xs: 12,
                    sm: 6,
                    md: 3,
                    lg: 3,
                    getListData: executiveListAPI,
                    apiRequest: {
                        OrganizationId: User === null || User === void 0 ? void 0 : User.OrganizationId
                    },
                    valueExpr: 'id',
                    displayExpr: 'GivenName',
                    apiKey: 'executiveList',
                    label: 'Executive',
                    placeholder: ' Select executive'
                }, {
                    type: FormItemTypes.DateTimePicker,
                    name: 'ValidTillDateTime',
                    xs: 12,
                    sm: 6,
                    md: 3,
                    lg: 3,
                    label: 'Order valid till'
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Contract details',
            value: null,
            columnSize: 12,
            containerProps: {
                spacing: 0
            },
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    width: 'auto',
                    sx: {
                        overflowX: 'auto',
                        overflowY: 'visible',
                        flexWrap: 'nowrap',
                        width: '100%',
                        scrollbarWidth: 'none'
                    },
                    position: 'static',
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 0,
                            sx: {
                                padding: '6px',
                                bgcolor: 'secondary.100',
                                borderColor: 'secondary.200'
                            },
                            contentProps: {
                                spacing: 0.5
                            },
                            elements: [{
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'New',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$VehicleContrac3;
                                        var newcontractCount = (state === null || state === void 0 || (_state$VehicleContrac3 = state.VehicleContractDetails) === null || _state$VehicleContrac3 === void 0 || (_state$VehicleContrac3 = _state$VehicleContrac3.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac3 === void 0 || (_state$VehicleContrac3 = _state$VehicleContrac3.Items) === null || _state$VehicleContrac3 === void 0 ? void 0 : _state$VehicleContrac3.length) || 0;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['New', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary',
                                                        display: newcontractCount ? 'inline-flex' : 'none'
                                                    },
                                                    label: newcontractCount
                                                })]
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.Button,
                                    label: '',
                                    name: 'Active',
                                    columnSize: 0,
                                    variant: 'text',
                                    color: 'secondary',
                                    size: 'small',
                                    fullWidth: true,
                                    setFormState: function (state, val, field) { return __awaiter(void 0, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            return [2 /*return*/, {
                                                    SelectedButton: field.name
                                                }];
                                        });
                                    }); },
                                    setFieldProps: function (state, value) {
                                        var _state$ActiveContract, _state$ActiveContract2, _state$ActiveContract3;
                                        return {
                                            type: FormItemTypes.Button,
                                            variant: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'outlined' : 'text',
                                            color: 'secondary',
                                            sx: {
                                                fontWeight: 'strong',
                                                color: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'text.primary' : undefined,
                                                bgcolor: (state === null || state === void 0 ? void 0 : state.SelectedButton) === this.name ? 'white' : "secondary.100"
                                            },
                                            children: ['Active', /*#__PURE__*/ React.createElement(Chip, {
                                                    variant: "filled",
                                                    size: "small",
                                                    color: "secondary",
                                                    sx: {
                                                        fontWeight: 'medium',
                                                        color: 'text.primary',
                                                        display: state !== null && state !== void 0 && (_state$ActiveContract = state.ActiveContracts) !== null && _state$ActiveContract !== void 0 && _state$ActiveContract.length ? 'inline-flex' : 'none'
                                                    },
                                                    label: (_state$ActiveContract2 = state === null || state === void 0 || (_state$ActiveContract3 = state.ActiveContracts) === null || _state$ActiveContract3 === void 0 ? void 0 : _state$ActiveContract3.length) !== null && _state$ActiveContract2 !== void 0 ? _state$ActiveContract2 : 0
                                                })]
                                        };
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'data',
                    columnSize: 12,
                    spacing: 2.5,
                    setFieldProps: function (state) {
                        var _state$NewContracts;
                        return {
                            type: FormItemTypes.ContainerItem,
                            elements: state === null || state === void 0 || (_state$NewContracts = state.NewContracts) === null || _state$NewContracts === void 0 ? void 0 : _state$NewContracts.map(function (newContract, index) {
                                var _state$VehicleContrac4, _newContract$TotalAmo;
                                var matchedItem = state === null || state === void 0 || (_state$VehicleContrac4 = state.VehicleContractDetails) === null || _state$VehicleContrac4 === void 0 || (_state$VehicleContrac4 = _state$VehicleContrac4.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac4 === void 0 || (_state$VehicleContrac4 = _state$VehicleContrac4.Items) === null || _state$VehicleContrac4 === void 0 ? void 0 : _state$VehicleContrac4.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (newContract === null || newContract === void 0 ? void 0 : newContract.ChildId); });
                                var isAdded = !!matchedItem;
                                return {
                                    type: FormItemTypes.CardComponent,
                                    name: '',
                                    xs: 12,
                                    sm: 6,
                                    md: 4,
                                    lg: 3,
                                    contentProps: {
                                        spacing: 0
                                    },
                                    containerProps: {
                                        position: 'relative'
                                    },
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.CardComponent,
                                        sx: {
                                            p: 0,
                                            borderRadius: '12px',
                                            borderColor: isAdded ? 'primary.200' : "secondary.200"
                                        }
                                    }); },
                                    elements: [{
                                            type: FormItemTypes.Icon,
                                            name: '',
                                            children: /*#__PURE__*/ React.createElement(CheckSVGIcon, {
                                                height: 24,
                                                width: 24,
                                                fill: "currentColor"
                                            }),
                                            columnSize: 12,
                                            color: 'primary',
                                            setFieldProps: function (state) { return ({
                                                type: FormItemTypes.Icon,
                                                sx: {
                                                    display: isAdded ? 'block' : 'none',
                                                    position: 'absolute',
                                                    right: -10,
                                                    top: 10
                                                }
                                            }); }
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '16px',
                                            elements: [{
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    spacing: 0,
                                                    columnSize: 12,
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    elements: [{
                                                            type: FormItemTypes.Typography,
                                                            name: 'Code',
                                                            value: newContract === null || newContract === void 0 ? void 0 : newContract.ChildCode,
                                                            columnSize: 0,
                                                            fontSize: 'sm',
                                                            fontWeight: 'medium',
                                                            color: 'secondary.600'
                                                        }, {
                                                            type: FormItemTypes.Chip,
                                                            name: '',
                                                            label: 'New',
                                                            size: 'small',
                                                            color: 'primary',
                                                            shape: 'rounded',
                                                            columnSize: 0
                                                        }]
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: newContract === null || newContract === void 0 ? void 0 : newContract.ChildName,
                                                    columnSize: 12,
                                                    fontSize: 'lg',
                                                    fontWeight: 'medium'
                                                }]
                                        }, {
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            padding: '12px 16px 16px 16px',
                                            bgcolor: 'info.50',
                                            justifyContent: 'space-between',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: "\u20B9 ".concat((_newContract$TotalAmo = newContract === null || newContract === void 0 ? void 0 : newContract.TotalAmount) !== null && _newContract$TotalAmo !== void 0 ? _newContract$TotalAmo : 0),
                                                    fontSize: 'lg',
                                                    fontWeight: 'strong',
                                                    columnSize: 0
                                                },
                                                // {
                                                //   type: FormItemTypes.Typography,
                                                //   name: '',
                                                //   children: 'Inc. of taxes',
                                                //   fontSize: 'sm',
                                                //   fontWeight: 'medium',
                                                //   columnSize: 0,
                                                //   color: 'secondary.600'
                                                // },
                                                //   ]
                                                // },
                                                {
                                                    type: FormItemTypes.Button,
                                                    name: '',
                                                    variant: 'contained',
                                                    children: 'Add',
                                                    size: 'small',
                                                    startIcon: /*#__PURE__*/ React.createElement(PlusHeaderIcon, null),
                                                    columnSize: 0,
                                                    setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                        var res, _formValues$VehicleCo, updatedContracts, updatedVehicleContractDetails, previousGrandTotal, newTotalAmount, updatedGrandTotal;
                                                        return __generator(this, function (_a) {
                                                            switch (_a.label) {
                                                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                        type: 'Drawer',
                                                                        Component: ContractDetailsDrawer,
                                                                        componentProps: {
                                                                            data: newContract
                                                                        },
                                                                        containerProps: {
                                                                            PaperProps: {
                                                                                sx: {
                                                                                    width: {
                                                                                        xs: '100%',
                                                                                        sm: '350px'
                                                                                    },
                                                                                    borderRadius: {
                                                                                        xs: '8px 8px 0 0'
                                                                                    }
                                                                                }
                                                                            },
                                                                            anchor: IS_MOBILE ? 'bottom' : 'right'
                                                                        }
                                                                    }))];
                                                                case 1:
                                                                    res = _a.sent();
                                                                    console.log('res?.payload', res === null || res === void 0 ? void 0 : res.payload);
                                                                    if (res !== null && res !== void 0 && res.payload) {
                                                                        updatedContracts = __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.SelectedContracts) || []), true), [_objectSpread(_objectSpread({}, res === null || res === void 0 ? void 0 : res.payload), {}, {
                                                                                SystemName: 'ServiceContract',
                                                                                isSelected: true
                                                                            })], false);
                                                                        updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo = formValues.VehicleContractDetails) === null || _formValues$VehicleCo === void 0 ? void 0 : _formValues$VehicleCo.map(function (contract) {
                                                                            if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                    Items: contract.Items ? __spreadArray(__spreadArray([], contract.Items, true), [res === null || res === void 0 ? void 0 : res.payload], false) : [res === null || res === void 0 ? void 0 : res.payload]
                                                                                });
                                                                            }
                                                                            return contract;
                                                                        });
                                                                        previousGrandTotal = parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal) || 0;
                                                                        newTotalAmount = parseFloat(newContract === null || newContract === void 0 ? void 0 : newContract.TotalAmount) || 0;
                                                                        updatedGrandTotal = (previousGrandTotal + newTotalAmount).toFixed(2);
                                                                        return [2 /*return*/, {
                                                                                SelectedContracts: updatedContracts,
                                                                                GrandTotal: updatedGrandTotal,
                                                                                VehicleContractDetails: updatedVehicleContractDetails
                                                                            }];
                                                                    }
                                                                    return [2 /*return*/, {}];
                                                            }
                                                        });
                                                    }); },
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.Button,
                                                        sx: {
                                                            display: isAdded ? 'none' : undefined
                                                        }
                                                    }); }
                                                }, {
                                                    type: FormItemTypes.ContainerItem,
                                                    name: '',
                                                    columnSize: true,
                                                    spacing: 0,
                                                    flexDirection: 'row',
                                                    justifyContent: 'end',
                                                    columnGap: '16px',
                                                    setFieldProps: function (state) { return ({
                                                        type: FormItemTypes.ContainerItem,
                                                        sx: {
                                                            display: isAdded ? undefined : 'none'
                                                        }
                                                    }); },
                                                    elements: [{
                                                            type: FormItemTypes.Button,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CustomerCardEditIcon, null),
                                                            columnSize: 0,
                                                            color: 'secondary',
                                                            variant: 'outlined',
                                                            size: 'icon',
                                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var res, _formValues$NewContra, _formValues$VehicleCo2, updatedNewContracts, updatedVehicleContractDetails;
                                                                return __generator(this, function (_a) {
                                                                    switch (_a.label) {
                                                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                                                type: 'Drawer',
                                                                                Component: ContractDetailsDrawer,
                                                                                componentProps: {
                                                                                    data: matchedItem
                                                                                },
                                                                                containerProps: {
                                                                                    PaperProps: {
                                                                                        sx: {
                                                                                            width: {
                                                                                                xs: '100%',
                                                                                                sm: '350px'
                                                                                            }
                                                                                        }
                                                                                    },
                                                                                    anchor: IS_MOBILE ? 'bottom' : 'right'
                                                                                }
                                                                            }))];
                                                                        case 1:
                                                                            res = _a.sent();
                                                                            if (res !== null && res !== void 0 && res.payload) {
                                                                                updatedNewContracts = formValues === null || formValues === void 0 || (_formValues$NewContra = formValues.NewContracts) === null || _formValues$NewContra === void 0 ? void 0 : _formValues$NewContra.map(function (contract) { return contract.id === newContract.id ? _objectSpread(_objectSpread({}, contract), res.payload) : contract; });
                                                                                updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo2 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo2 === void 0 ? void 0 : _formValues$VehicleCo2.map(function (contract) {
                                                                                    if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                                        var _contract$Items;
                                                                                        return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                            Items: ((_contract$Items = contract.Items) === null || _contract$Items === void 0 ? void 0 : _contract$Items.map(function (item) { return item.id === newContract.id ? _objectSpread(_objectSpread({}, item), res.payload) : item; })) || []
                                                                                        });
                                                                                    }
                                                                                    return contract;
                                                                                });
                                                                                return [2 /*return*/, {
                                                                                        NewContracts: updatedNewContracts,
                                                                                        VehicleContractDetails: updatedVehicleContractDetails
                                                                                    }];
                                                                            }
                                                                            return [2 /*return*/, {}];
                                                                    }
                                                                });
                                                            }); }
                                                        }, {
                                                            type: FormItemTypes.Button,
                                                            name: '',
                                                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                                                height: '20px',
                                                                width: '20px'
                                                            }),
                                                            columnSize: 0,
                                                            color: 'primary',
                                                            variant: 'outlined',
                                                            sx: {
                                                                padding: '8px'
                                                            },
                                                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                                var _formValues$VehicleCo3, updatedVehicleContractDetails, previousGrandTotal, newTotalAmount, updatedGrandTotal;
                                                                return __generator(this, function (_a) {
                                                                    updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo3 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo3 === void 0 ? void 0 : _formValues$VehicleCo3.map(function (contract) {
                                                                        if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                            var _contract$Items2;
                                                                            return _objectSpread(_objectSpread({}, contract), {}, {
                                                                                Items: (contract === null || contract === void 0 || (_contract$Items2 = contract.Items) === null || _contract$Items2 === void 0 ? void 0 : _contract$Items2.filter(function (item) { return item.ChildId !== (newContract === null || newContract === void 0 ? void 0 : newContract.ChildId); })) || []
                                                                            });
                                                                        }
                                                                        return contract;
                                                                    });
                                                                    previousGrandTotal = parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal) || 0;
                                                                    newTotalAmount = parseFloat(newContract === null || newContract === void 0 ? void 0 : newContract.TotalAmount) || 0;
                                                                    updatedGrandTotal = (previousGrandTotal - newTotalAmount).toFixed(2);
                                                                    return [2 /*return*/, {
                                                                            GrandTotal: updatedGrandTotal,
                                                                            VehicleContractDetails: updatedVehicleContractDetails
                                                                        }];
                                                                });
                                                            }); }
                                                        }]
                                                }]
                                        }]
                                };
                            }),
                            sx: {
                                display: (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'New' ? undefined : 'none'
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'ActiveContracts',
                    columnSize: 12,
                    spacing: 2.2,
                    setFieldProps: function (state, currValue) { return ({
                        type: FormItemTypes.ContainerItem,
                        sx: {
                            display: (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'Active' ? undefined : 'none'
                        },
                        elements: currValue === null || currValue === void 0 ? void 0 : currValue.map(function (ActiveContract, index) {
                            var _state$VehicleContrac5, _ActiveContract$Renew, _ActiveContract$Price;
                            var isAdded = (state === null || state === void 0 || (_state$VehicleContrac5 = state.VehicleContractDetails) === null || _state$VehicleContrac5 === void 0 || (_state$VehicleContrac5 = _state$VehicleContrac5.find(function (contract) { return (contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (state === null || state === void 0 ? void 0 : state.selectedVehicle); })) === null || _state$VehicleContrac5 === void 0 || (_state$VehicleContrac5 = _state$VehicleContrac5.Items) === null || _state$VehicleContrac5 === void 0 ? void 0 : _state$VehicleContrac5.some(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.id); })) || false;
                            var effectiveTo = dayjs(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveTo);
                            var today = dayjs();
                            var daysLeft = effectiveTo.diff(today, 'day');
                            var renewableWindow = parseInt((_ActiveContract$Renew = ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.RenewableWindow) !== null && _ActiveContract$Renew !== void 0 ? _ActiveContract$Renew : "0", 10);
                            return {
                                type: FormItemTypes.Box,
                                name: '',
                                xs: 12,
                                sm: 6,
                                md: 4,
                                lg: 3,
                                border: '1px solid',
                                borderColor: "secondary.200",
                                borderRadius: '12px',
                                sx: {
                                    position: 'relative'
                                },
                                setFieldProps: function (state) { return ({
                                    type: FormItemTypes.Box,
                                    borderColor: isAdded ? 'primary.200' : "secondary.200"
                                }); },
                                elements: [{
                                        type: FormItemTypes.Icon,
                                        name: '',
                                        children: /*#__PURE__*/ React.createElement(CheckSVGIcon, {
                                            height: 24,
                                            width: 24,
                                            fill: "currentColor"
                                        }),
                                        columnSize: 12,
                                        color: 'primary',
                                        setFieldProps: function (state) { return ({
                                            type: FormItemTypes.Icon,
                                            sx: {
                                                display: isAdded ? 'block' : 'none',
                                                position: 'absolute',
                                                right: -10,
                                                top: -10
                                            }
                                        }); }
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        columnSize: 12,
                                        spacing: 0,
                                        padding: '16px',
                                        gap: '16px',
                                        elements: [{
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        spacing: 0,
                                                        columnSize: 12,
                                                        justifyContent: 'space-between',
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: '',
                                                                value: "#".concat(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.ChildCode),
                                                                columnSize: 0,
                                                                fontSize: 'sm',
                                                                fontWeight: 'medium',
                                                                color: 'secondary.600'
                                                            }, {
                                                                type: FormItemTypes.Chip,
                                                                name: '',
                                                                label: 'Active',
                                                                size: 'small',
                                                                color: 'primary',
                                                                shape: 'rounded',
                                                                columnSize: 0
                                                            }]
                                                    }, {
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        value: ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.ChildName,
                                                        columnSize: 12,
                                                        fontSize: 'lg',
                                                        fontWeight: 'medium'
                                                    }]
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                columnSize: 12,
                                                spacing: 0,
                                                bgcolor: 'background.secondary',
                                                borderRadius: '8px',
                                                padding: '12px',
                                                gap: '8px',
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        label: 'Effective from:',
                                                        value: ActiveContract !== null && ActiveContract !== void 0 && ActiveContract.EffectiveFrom ? dayjs(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveFrom).format('DD MMM, YYYY') : '',
                                                        containerProps: {
                                                            display: 'inline-flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'baseline',
                                                            gap: 1
                                                        },
                                                        labelTypographyProps: {
                                                            mb: 0,
                                                            noWrap: true,
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm'
                                                        },
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm',
                                                        columnSize: 12
                                                    }, {
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        columnSize: 12,
                                                        spacing: 0,
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: 'sdas',
                                                                label: 'Effective till:',
                                                                value: ActiveContract !== null && ActiveContract !== void 0 && ActiveContract.EffectiveTo ? dayjs(ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.EffectiveTo).format('DD MMM, YYYY') : '',
                                                                containerProps: {
                                                                    display: 'inline-flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'baseline',
                                                                    gap: 1
                                                                },
                                                                labelTypographyProps: {
                                                                    mb: 0,
                                                                    noWrap: true,
                                                                    fontWeight: 'medium',
                                                                    fontSize: 'sm'
                                                                },
                                                                fontWeight: 'medium',
                                                                fontSize: 'sm',
                                                                columnSize: 12
                                                            }, {
                                                                type: FormItemTypes.Typography,
                                                                name: '',
                                                                value: daysLeft > 0 ? "Expiring in ".concat(daysLeft, " days") : "Expired ".concat(Math.abs(daysLeft), " days ago"),
                                                                color: 'error.500',
                                                                fontSize: 'sm',
                                                                textAlign: 'end',
                                                                fontWeight: 'medium',
                                                                columnSize: 12,
                                                                sx: {
                                                                    display: daysLeft > 0 && daysLeft <= renewableWindow ? undefined : 'none'
                                                                }
                                                            }]
                                                    }]
                                            }]
                                    }, {
                                        type: FormItemTypes.ContainerItem,
                                        name: '',
                                        columnSize: 12,
                                        spacing: 0,
                                        padding: '12px 16px 16px 16px',
                                        borderRadius: '0 0 12px 12px',
                                        bgcolor: 'info.50',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: '',
                                                value: "\u20B9 ".concat((_ActiveContract$Price = ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.Price) !== null && _ActiveContract$Price !== void 0 ? _ActiveContract$Price : 0),
                                                fontSize: 'lg',
                                                fontWeight: 'strong',
                                                columnSize: true
                                            }, (ActiveContract === null || ActiveContract === void 0 ? void 0 : ActiveContract.IsRenewable) && {
                                                type: FormItemTypes.Button,
                                                name: '',
                                                variant: 'contained',
                                                children: 'Renew',
                                                size: 'small',
                                                columnSize: 0,
                                                setFieldProps: function (state) { return ({
                                                    type: FormItemTypes.Button,
                                                    sx: {
                                                        display: isAdded ? 'none' : undefined
                                                    }
                                                }); },
                                                setFormState: function (formValues, currValue) { return __awaiter(void 0, void 0, void 0, function () {
                                                    var _formValues$VehicleCo4, updatedContracts, updatedVehicleContractDetails;
                                                    return __generator(this, function (_a) {
                                                        updatedContracts = __spreadArray(__spreadArray([], ((formValues === null || formValues === void 0 ? void 0 : formValues.SelectedContracts) || []), true), [_objectSpread(_objectSpread({}, ActiveContract), {}, {
                                                                isSelected: true
                                                            })], false);
                                                        updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo4 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo4 === void 0 ? void 0 : _formValues$VehicleCo4.map(function (contract) {
                                                            if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    Items: contract.Items ? __spreadArray(__spreadArray([], contract.Items, true), [ActiveContract], false) : [ActiveContract]
                                                                });
                                                            }
                                                            return contract;
                                                        });
                                                        return [2 /*return*/, {
                                                                SelectedContracts: updatedContracts,
                                                                VehicleContractDetails: updatedVehicleContractDetails
                                                            }];
                                                    });
                                                }); }
                                            }, isAdded ? {
                                                type: FormItemTypes.Button,
                                                name: '',
                                                children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                                    height: '20px',
                                                    width: '20px'
                                                }),
                                                columnSize: 0,
                                                color: 'primary',
                                                variant: 'outlined',
                                                size: 'icon',
                                                setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                                    var _formValues$SelectedC, _formValues$VehicleCo5, updatedContracts, updatedVehicleContractDetails;
                                                    return __generator(this, function (_a) {
                                                        updatedContracts = formValues === null || formValues === void 0 || (_formValues$SelectedC = formValues.SelectedContracts) === null || _formValues$SelectedC === void 0 ? void 0 : _formValues$SelectedC.filter(function (contract) { return contract.id !== ActiveContract.id; });
                                                        updatedVehicleContractDetails = formValues === null || formValues === void 0 || (_formValues$VehicleCo5 = formValues.VehicleContractDetails) === null || _formValues$VehicleCo5 === void 0 ? void 0 : _formValues$VehicleCo5.map(function (contract) {
                                                            if ((contract === null || contract === void 0 ? void 0 : contract.RegistrationNo) === (formValues === null || formValues === void 0 ? void 0 : formValues.selectedVehicle)) {
                                                                var _contract$Items3;
                                                                return _objectSpread(_objectSpread({}, contract), {}, {
                                                                    Items: (contract === null || contract === void 0 || (_contract$Items3 = contract.Items) === null || _contract$Items3 === void 0 ? void 0 : _contract$Items3.filter(function (item) { return item.ChildId !== ActiveContract.ChildId; })) || []
                                                                });
                                                            }
                                                            return contract;
                                                        });
                                                        return [2 /*return*/, {
                                                                SelectedContracts: updatedContracts,
                                                                VehicleContractDetails: updatedVehicleContractDetails
                                                            }];
                                                    });
                                                }); }
                                            } : null]
                                    }]
                            };
                        })
                    }); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    setFieldProps: function (state) {
                        var _state$ActiveContract4, _state$NewContracts2;
                        return console.log('state', state), {
                            type: FormItemTypes.ContainerItem,
                            sx: {
                                display: (state === null || state === void 0 || (_state$ActiveContract4 = state.ActiveContracts) === null || _state$ActiveContract4 === void 0 ? void 0 : _state$ActiveContract4.length) === 0 && (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'Active' || (state === null || state === void 0 || (_state$NewContracts2 = state.NewContracts) === null || _state$NewContracts2 === void 0 ? void 0 : _state$NewContracts2.length) === 0 && (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'New' ? 'inline-flex' : 'none'
                            }
                        };
                    },
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(NoDocumenetsIcon, null),
                            columnSize: 0,
                            sx: {
                                color: 'info.600',
                                p: 0,
                                cursor: 'none'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'title',
                            children: '',
                            columnSize: 12,
                            fontSize: 'xl',
                            fontWeight: 'strong',
                            textAlign: 'center',
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Typography,
                                children: (state === null || state === void 0 ? void 0 : state.SelectedButton) === 'New' ? 'No new contracts available' : 'No active contracts available'
                            }); }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'title',
                            children: 'There is no new contract available for this vehicle',
                            columnSize: 12,
                            fontSize: 'base',
                            fontWeight: 'normal',
                            color: 'secondary.500',
                            textAlign: 'center',
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Typography,
                                children: "There is no ".concat((state === null || state === void 0 ? void 0 : state.SelectedButton) === 'New' ? 'new' : 'active', " contract available for this vehicle")
                            }); }
                        }]
                }]
        }];
    var ADDITIONAL_INFO = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            label: 'Additional info',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.CardComponent,
                sx: {
                    display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    xs: 12,
                    sm: 12,
                    md: 8,
                    lg: 8,
                    multiline: true,
                    minRows: 5,
                    label: 'Remarks (0/200)',
                    maxLength: 200,
                    placeholder: 'Enter a description...',
                    setFieldProps: function (formValues, value) {
                        var _value$length;
                        return {
                            type: this.type,
                            label: "Remarks (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 )"),
                            inputProps: {
                                maxLength: 200
                            }
                        };
                    }
                }]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            paddingInline: IS_MOBILE ? '16px' : '24px',
            pt: '16px',
            pb: "20px",
            position: 'relative',
            gap: '16px',
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    alignItems: 'center',
                    gap: '16px',
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                navigate('/contractSaleOrder');
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            columnSize: true,
                            alignItems: 'center',
                            sx: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'start'
                                }
                            },
                            gap: '12px',
                            elements: [{
                                    type: FormItemTypes.Box,
                                    name: '',
                                    display: 'flex',
                                    alignItems: 'center',
                                    columnSize: true,
                                    gap: '12px',
                                    justifyContent: id && IS_MOBILE ? 'space-between' : 'start',
                                    elements: [{
                                            type: FormItemTypes.Typography,
                                            name: '',
                                            value: id ? 'Contract sale order details' : 'New contract sale order',
                                            fontWeight: 'strong',
                                            fontSize: IS_MOBILE ? 'lg' : 'xxl',
                                            columnSize: 0
                                        }, id ? {
                                            type: FormItemTypes.Chip,
                                            name: '',
                                            columnSize: 0,
                                            sx: {
                                                borderRadius: '6px',
                                                height: '24px',
                                                fontWeight: 'medium'
                                            },
                                            size: 'medium',
                                            setFieldProps: function (state) {
                                                var _state$Status$Display, _state$Status, _state$Status$Display2, _state$Status2, _state$Status3;
                                                return console.log('state', state), {
                                                    type: FormItemTypes.Chip,
                                                    label: "".concat((_state$Status$Display = state === null || state === void 0 || (_state$Status = state.Status) === null || _state$Status === void 0 ? void 0 : _state$Status.DisplayName) !== null && _state$Status$Display !== void 0 ? _state$Status$Display : ""),
                                                    color: getStatusColor((_state$Status$Display2 = state === null || state === void 0 || (_state$Status2 = state.Status) === null || _state$Status2 === void 0 ? void 0 : _state$Status2.DisplayName) !== null && _state$Status$Display2 !== void 0 ? _state$Status$Display2 : "").color,
                                                    sx: {
                                                        borderRadius: '6px',
                                                        height: '24px',
                                                        fontWeight: 'medium',
                                                        display: state !== null && state !== void 0 && (_state$Status3 = state.Status) !== null && _state$Status3 !== void 0 && _state$Status3.DisplayName ? undefined : 'none'
                                                    }
                                                };
                                            }
                                        } : null]
                                }]
                        }]
                }, id ? {
                    type: FormItemTypes.Typography,
                    name: 'OrderDate',
                    label: 'DOC DATE:',
                    containerProps: {
                        display: 'inline-flex',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                        gap: 1
                    },
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'strong'
                    },
                    columnSize: IS_MOBILE ? 12 : 0,
                    valueGetter: function (formValues, field) {
                        return dateFormate(formValues === null || formValues === void 0 ? void 0 : formValues.OrderDate);
                    }
                } : null]
        }, {
            type: FormItemTypes.Box,
            name: '',
            height: '68px',
            padding: '16px 24px',
            gap: '12px',
            bgcolor: 'secondary.100',
            borderTop: '1px solid ',
            borderBottom: '1px solid ',
            borderColor: 'secondary.200',
            columnSize: 12,
            justifyContent: id ? 'end' : 'space-between',
            display: IS_MOBILE && id ? 'none' : 'flex',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    sx: {
                        display: id ? 'none' : undefined
                    },
                    elements: [{
                            type: FormItemTypes.SingleSelect,
                            name: 'Key',
                            value: searchType[0].id,
                            options: searchType,
                            displayExpr: 'label',
                            variant: 'standard',
                            disableUnderline: true,
                            sx: {
                                minWidth: 90
                            },
                            columnSize: 0,
                            setFormState: function () {
                                return {
                                    Value: ''
                                };
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by Reg No, VIN, Mobile',
                            InputProps: {
                                disableUnderline: true
                            },
                            setFormState: function () {
                                return {
                                    success: false
                                };
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            },
                            setFieldProps: function (formValues, currValue, field) {
                                var maxLength;
                                switch (formValues === null || formValues === void 0 ? void 0 : formValues.Key) {
                                    case 'RegistrationNo':
                                        maxLength = 12;
                                        break;
                                    case 'Mobile':
                                        maxLength = 10;
                                        break;
                                    case 'VinNo':
                                        maxLength = 17;
                                        break;
                                    default:
                                        maxLength = undefined;
                                }
                                return {
                                    type: FormItemTypes.TextInput,
                                    maxLength: maxLength
                                };
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            setFormState: getInstallbase,
                            setFieldProps: function (formValues, currValue, field) {
                                var _formValues$Key, _formValues$Value, _formValues$Value2, _formValues$Value3, _formValues$Value4;
                                console.log('formValues', formValues);
                                var disabled = true;
                                if ((formValues === null || formValues === void 0 || (_formValues$Key = formValues.Key) === null || _formValues$Key === void 0 ? void 0 : _formValues$Key.toLowerCase()) === 'registrationno' && (formValues === null || formValues === void 0 || (_formValues$Value = formValues.Value) === null || _formValues$Value === void 0 ? void 0 : _formValues$Value.length) >= 4 && (formValues === null || formValues === void 0 || (_formValues$Value2 = formValues.Value) === null || _formValues$Value2 === void 0 ? void 0 : _formValues$Value2.length) <= 12) {
                                    disabled = false;
                                }
                                else if ((formValues === null || formValues === void 0 ? void 0 : formValues.Key) === 'VinNo' && (formValues === null || formValues === void 0 || (_formValues$Value3 = formValues.Value) === null || _formValues$Value3 === void 0 ? void 0 : _formValues$Value3.length) === 17) {
                                    disabled = false;
                                }
                                else if ((formValues === null || formValues === void 0 ? void 0 : formValues.Key) === 'Mobile' && (formValues === null || formValues === void 0 || (_formValues$Value4 = formValues.Value) === null || _formValues$Value4 === void 0 ? void 0 : _formValues$Value4.length) === 10) {
                                    disabled = false;
                                }
                                return {
                                    type: FormItemTypes.IconButton,
                                    disabled: disabled
                                };
                            }
                        }]
                }, !IS_MOBILE ? {
                    type: FormItemTypes.Box,
                    name: '',
                    justifyContent: 'end',
                    display: 'flex',
                    columnSize: 9,
                    gap: '12px',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: IS_DESKTOP ? 'Quick links' : '',
                            columnSize: 0,
                            sx: {
                                bgcolor: 'transparent',
                                fontWeight: 'medium'
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null),
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button,
                                disabled: state !== null && state !== void 0 && state.selectedVehicle ? false : true
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareIcon, {
                                height: 20,
                                width: 20,
                                color: "secondary"
                            }),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                padding: '8px'
                            },
                            disabled: true
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            variant: 'fullWidth',
                            orientation: 'vertical',
                            columnSize: 0
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'text',
                            children: 'Discard',
                            color: 'secondary',
                            columnSize: 0,
                            disabled: true,
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button,
                                disabled: state !== null && state !== void 0 && state.selectedVehicle ? false : true
                            }); },
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: CSODiscard,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: '350px',
                                                            borderRadius: '8px'
                                                        }
                                                    }
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            console.log('Response', res);
                                            if ((res === null || res === void 0 ? void 0 : res.payload) === "discard") {
                                                navigate('/contractSaleOrder');
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            variant: 'contained',
                            children: 'Save',
                            color: 'primary',
                            columnSize: 0,
                            setFieldProps: function (state) {
                                var _state$VehicleContrac6, _state$VehicleContrac7;
                                return {
                                    type: FormItemTypes.Button,
                                    disabled: !(state !== null && state !== void 0 && state.VehicleContractDetails && (state === null || state === void 0 || (_state$VehicleContrac6 = state.VehicleContractDetails) === null || _state$VehicleContrac6 === void 0 ? void 0 : _state$VehicleContrac6.length) > 0 && state !== null && state !== void 0 && (_state$VehicleContrac7 = state.VehicleContractDetails) !== null && _state$VehicleContrac7 !== void 0 && _state$VehicleContrac7.every(function (item) {
                                        var _item$Items;
                                        return Array.isArray(item.Items) && (item === null || item === void 0 || (_item$Items = item.Items) === null || _item$Items === void 0 ? void 0 : _item$Items.length) > 0;
                                    }))
                                };
                            },
                            setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                                var _formValues$Customer, _formValues$InstallBa2, _formValues$Customer2, _formValues$PrimaryCo6, _res$payload2, _res$payload3, req, res, _res$payload4, successRes, _res$payload5;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            req = {
                                                CustomerId: formValues === null || formValues === void 0 || (_formValues$Customer = formValues.Customer) === null || _formValues$Customer === void 0 ? void 0 : _formValues$Customer.CustomerId,
                                                ParentEntityId: id ? null : formValues === null || formValues === void 0 || (_formValues$InstallBa2 = formValues.InstallBase[0]) === null || _formValues$InstallBa2 === void 0 ? void 0 : _formValues$InstallBa2.SchemaId,
                                                OrderId: id ? formValues === null || formValues === void 0 ? void 0 : formValues.OrderId : null,
                                                SubTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                                TotalDiscount: 0,
                                                OtherCharges: 0,
                                                TotalTax: 0,
                                                GrandTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                                ApprovedById: formValues === null || formValues === void 0 ? void 0 : formValues.ApprovedById,
                                                ValidTillDateTime: formValues === null || formValues === void 0 ? void 0 : formValues.ValidTillDateTime,
                                                Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                                OrganizationId: User === null || User === void 0 ? void 0 : User.OrganizationId,
                                                ParentOrganizationId: User === null || User === void 0 ? void 0 : User.ParentOrganizationId,
                                                PersonId: formValues === null || formValues === void 0 || (_formValues$Customer2 = formValues.Customer) === null || _formValues$Customer2 === void 0 ? void 0 : _formValues$Customer2.PersonId,
                                                PersonContactPointId: formValues === null || formValues === void 0 || (_formValues$PrimaryCo6 = formValues.PrimaryContact) === null || _formValues$PrimaryCo6 === void 0 ? void 0 : _formValues$PrimaryCo6.id,
                                                CGST_Amount: 0,
                                                CGST_Percentage: 0,
                                                SGST_UTGST_Amount: 0,
                                                SGST_UTGST_Percentage: 0,
                                                IGST_Amount: 0,
                                                IGST_Percentage: 0,
                                                SystemName: 'ServiceContract',
                                                VehicleContractDetails: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails
                                            };
                                            return [4 /*yield*/, dispatch(showLoader({
                                                    isLoaderOpen: true
                                                }))];
                                        case 1:
                                            _a.sent();
                                            return [4 /*yield*/, dispatch(getListAPI({
                                                    key: ContractSaleOrderKeys.UpsertContractSaleOrder,
                                                    url: UsertContractSaleOrderURL,
                                                    request: req
                                                }))];
                                        case 2:
                                            res = _a.sent();
                                            if (!(res !== null && res !== void 0 && (_res$payload2 = res.payload) !== null && _res$payload2 !== void 0 && (_res$payload2 = _res$payload2.value) !== null && _res$payload2 !== void 0 && _res$payload2.success && (res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 || (_res$payload3 = _res$payload3.value) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.statusCode) == 200)) return [3 /*break*/, 5];
                                            return [4 /*yield*/, dispatch(showLoader({
                                                    isLoaderOpen: false
                                                }))];
                                        case 3:
                                            _a.sent();
                                            return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: CSOSaveSuccessfullPopUp,
                                                    containerProps: {
                                                        PaperProps: {
                                                            sx: {
                                                                width: '400px',
                                                                borderRadius: '8px'
                                                            }
                                                        }
                                                    },
                                                    componentProps: {
                                                        data: res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.value) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.data
                                                    }
                                                }))];
                                        case 4:
                                            successRes = _a.sent();
                                            if ((successRes === null || successRes === void 0 ? void 0 : successRes.payload) === "goHome") {
                                                navigate('/contractSaleOrder');
                                            }
                                            else if ((successRes === null || successRes === void 0 ? void 0 : successRes.payload) === "invoice") {
                                                navigate("/createContractSaleInvoice/".concat(res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.value) === null || _res$payload5 === void 0 || (_res$payload5 = _res$payload5.data) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.id, "?mode=edit"));
                                            }
                                            _a.label = 5;
                                        case 5: return [4 /*yield*/, dispatch(showLoader({
                                                isLoaderOpen: false
                                            }))];
                                        case 6:
                                            _a.sent();
                                            return [2 /*return*/, {}];
                                    }
                                });
                            }); }
                        }]
                } : null]
        }, {
            type: FormItemTypes.Stack,
            name: '',
            columnSize: 12,
            height: '212px',
            width: "100%",
            justifyContent: 'center',
            alignItems: 'center',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.resultnotfound ? undefined : 'none'
                },
                elements: [{
                        type: FormItemTypes.Stack,
                        name: '',
                        width: '270px',
                        gap: '16px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        elements: [{
                                type: FormItemTypes.Button,
                                name: '',
                                color: 'secondary',
                                variant: 'outlined',
                                children: /*#__PURE__*/ React.createElement(Search, {
                                    color: "secondary"
                                }),
                                columnSize: 0
                            }, {
                                type: FormItemTypes.Stack,
                                name: '',
                                columnSize: 12,
                                gap: '4px',
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: 'Result not found',
                                        fontSize: 'lg',
                                        fontWeight: 'strong',
                                        textAlign: 'center',
                                        columnSize: 12
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: '',
                                        children: "Your search \u201C".concat(state === null || state === void 0 ? void 0 : state.Value, "\u201D did not match any ").concat(state === null || state === void 0 ? void 0 : state.Key, ". Please try again."),
                                        columnSize: 12,
                                        color: 'secondary.500',
                                        textAlign: 'center'
                                    }]
                            }]
                    }]
            }); }
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            position: 'relative',
            setFieldProps: function (state) { return ({
                type: FormItemTypes.ContainerItem,
                sx: {
                    display: state !== null && state !== void 0 && state.success ? undefined : id ? undefined : 'none'
                }
            }); },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: 'Tabs',
                    columnSize: 12,
                    valueExpr: 'id',
                    displayExpr: 'Name',
                    panelGridProps: {
                        spacing: 2,
                        px: 3
                    },
                    tabs: [{
                            id: 'general',
                            Name: 'General',
                            elements: generalFields
                        }, {
                            id: 'additional-info',
                            Name: 'Additional info',
                            elements: ADDITIONAL_INFO
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    padding: '20px 24px',
                    borderTop: '1px solid',
                    borderColor: 'secondary.200',
                    position: 'sticky',
                    bottom: IS_MOBILE ? 71 : 0,
                    zIndex: 10,
                    height: '84px',
                    bgcolor: 'secondary.50',
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.ContainerItem,
                        sx: {
                            display: state !== null && state !== void 0 && state.selectedVehicle ? undefined : 'none'
                        }
                    }); },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'orderSummary',
                            variant: 'outlined',
                            fullWidth: true,
                            color: 'secondary',
                            sx: {
                                bgcolor: 'white'
                            },
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 4,
                            startIcon: /*#__PURE__*/ React.createElement(RightArrow, {
                                color: "text.secondary",
                                height: 20,
                                width: 20
                            }),
                            setFieldProps: function (state) { return ({
                                type: FormItemTypes.Button,
                                children: /*#__PURE__*/ React.createElement(Stack, {
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    direction: 'row',
                                    color: 'secondary.900'
                                }, " ", /*#__PURE__*/ React.createElement(Typography, {
                                    fontWeight: 'strong'
                                }, "Total amount"), /*#__PURE__*/ React.createElement(Typography, {
                                    fontWeight: 'strong'
                                }, "\u20B9 ", Number(state === null || state === void 0 ? void 0 : state.GrandTotal) ? Number(state === null || state === void 0 ? void 0 : state.GrandTotal).toFixed(2) : 0..toFixed(2)))
                            }); },
                            setFormState: function (formValues, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var _e$target, _e$target2, _rect$top, rect, res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            rect = e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 || (_e$target = _e$target.closest('button')) === null || _e$target === void 0 ? void 0 : _e$target.getBoundingClientRect();
                                            return [4 /*yield*/, IS_MOBILE];
                                        case 1:
                                            res = (_a.sent()) ? dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: OrderSummaryPopup,
                                                containerProps: {
                                                    anchor: 'bottom',
                                                    PaperProps: {
                                                        sx: {
                                                            borderRadius: '8px 8px 0 0'
                                                        }
                                                    }
                                                },
                                                componentProps: {
                                                    formValues: formValues
                                                }
                                            })) : dispatch(showSurface({
                                                type: 'Menu',
                                                Component: OrderSummaryPopup,
                                                componentProps: {
                                                    formValues: formValues
                                                },
                                                containerProps: {
                                                    anchorEl: e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.closest('#orderSummary'),
                                                    anchorOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    },
                                                    slotProps: {
                                                        paper: {
                                                            sx: {
                                                                bottom: "calc(100svh - ".concat(((_rect$top = rect === null || rect === void 0 ? void 0 : rect.top) !== null && _rect$top !== void 0 ? _rect$top : 0) - 10, "px)"),
                                                                top: 'unset !important'
                                                            }
                                                        }
                                                    }
                                                }
                                            }));
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                }]
        }, IS_MOBILE ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'fixed',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 2,
            width: '100%',
            justifyContent: 'space-between',
            sx: {
                borderTop: '1px solid ',
                borderColor: 'secondary.200',
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    id: "createDocument",
                    name: '',
                    children: 'Discard ',
                    variant: 'text',
                    color: 'secondary',
                    columnSize: 0,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Button,
                        disabled: state !== null && state !== void 0 && state.selectedVehicle ? false : true
                    }); },
                    onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Drawer',
                                        Component: CSODiscard,
                                        containerProps: {
                                            PaperProps: {
                                                sx: {
                                                    width: '100vw',
                                                    borderRadius: '8px 8px 0 0'
                                                }
                                            },
                                            anchor: 'bottom'
                                        }
                                    }))];
                                case 1:
                                    res = _a.sent();
                                    if ((res === null || res === void 0 ? void 0 : res.payload) === "discard") {
                                        navigate('/contractSaleOrder');
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.Button,
                    id: "createDocument",
                    name: '',
                    children: 'Save',
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 0,
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Button,
                        disabled: state !== null && state !== void 0 && state.selectedVehicle ? false : true
                    }); },
                    setFormState: function (formValues, currValue, field) { return __awaiter(void 0, void 0, void 0, function () {
                        var _formValues$Customer3, _formValues$InstallBa3, _formValues$Customer4, _formValues$PrimaryCo7, _res$payload6, _res$payload7, req, res, _res$payload8, successRes, _res$payload9;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    req = {
                                        CustomerId: formValues === null || formValues === void 0 || (_formValues$Customer3 = formValues.Customer) === null || _formValues$Customer3 === void 0 ? void 0 : _formValues$Customer3.CustomerId,
                                        ParentEntityId: id ? null : formValues === null || formValues === void 0 || (_formValues$InstallBa3 = formValues.InstallBase[0]) === null || _formValues$InstallBa3 === void 0 ? void 0 : _formValues$InstallBa3.SchemaId,
                                        OrderId: id ? formValues === null || formValues === void 0 ? void 0 : formValues.OrderId : null,
                                        SubTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                        TotalDiscount: 0,
                                        OtherCharges: 0,
                                        TotalTax: 0,
                                        GrandTotal: parseFloat(formValues === null || formValues === void 0 ? void 0 : formValues.GrandTotal),
                                        ApprovedById: formValues === null || formValues === void 0 ? void 0 : formValues.ApprovedById,
                                        ValidTillDateTime: formValues === null || formValues === void 0 ? void 0 : formValues.ValidTillDateTime,
                                        Remarks: formValues === null || formValues === void 0 ? void 0 : formValues.Remarks,
                                        OrganizationId: User === null || User === void 0 ? void 0 : User.OrganizationId,
                                        ParentOrganizationId: User === null || User === void 0 ? void 0 : User.ParentOrganizationId,
                                        PersonId: formValues === null || formValues === void 0 || (_formValues$Customer4 = formValues.Customer) === null || _formValues$Customer4 === void 0 ? void 0 : _formValues$Customer4.PersonId,
                                        PersonContactPointId: formValues === null || formValues === void 0 || (_formValues$PrimaryCo7 = formValues.PrimaryContact) === null || _formValues$PrimaryCo7 === void 0 ? void 0 : _formValues$PrimaryCo7.id,
                                        CGST_Amount: 0,
                                        CGST_Percentage: 0,
                                        SGST_UTGST_Amount: 0,
                                        SGST_UTGST_Percentage: 0,
                                        IGST_Amount: 0,
                                        IGST_Percentage: 0,
                                        SystemName: 'ServiceContract',
                                        VehicleContractDetails: formValues === null || formValues === void 0 ? void 0 : formValues.VehicleContractDetails
                                    };
                                    return [4 /*yield*/, dispatch(showLoader({
                                            isLoaderOpen: true
                                        }))];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            key: ContractSaleOrderKeys.UpsertContractSaleOrder,
                                            url: UsertContractSaleOrderURL,
                                            request: req
                                        }))];
                                case 2:
                                    res = _a.sent();
                                    if (!(res !== null && res !== void 0 && (_res$payload6 = res.payload) !== null && _res$payload6 !== void 0 && (_res$payload6 = _res$payload6.value) !== null && _res$payload6 !== void 0 && _res$payload6.success && (res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 || (_res$payload7 = _res$payload7.value) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.statusCode) == 200)) return [3 /*break*/, 5];
                                    return [4 /*yield*/, dispatch(showLoader({
                                            isLoaderOpen: false
                                        }))];
                                case 3:
                                    _a.sent();
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: CSOSaveSuccessfullPopUp,
                                            containerProps: {
                                                PaperProps: {
                                                    sx: {
                                                        width: '100vw',
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                },
                                                anchor: 'bottom'
                                            },
                                            componentProps: {
                                                data: res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 || (_res$payload8 = _res$payload8.value) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.data
                                            }
                                        }))];
                                case 4:
                                    successRes = _a.sent();
                                    if ((successRes === null || successRes === void 0 ? void 0 : successRes.payload) === "goHome") {
                                        navigate('/contractSaleOrder');
                                    }
                                    else if ((successRes === null || successRes === void 0 ? void 0 : successRes.payload) === "invoice") {
                                        navigate("/createContractSaleInvoice/".concat(res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.value) === null || _res$payload9 === void 0 || (_res$payload9 = _res$payload9.data) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.id, "?mode=edit"));
                                    }
                                    _a.label = 5;
                                case 5: return [4 /*yield*/, dispatch(showLoader({
                                        isLoaderOpen: false
                                    }))];
                                case 6:
                                    _a.sent();
                                    return [2 /*return*/, {}];
                            }
                        });
                    }); }
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        gridProps: {
            spacing: 0,
            bgcolor: 'secondary.50'
        },
        getKey: 'ContractSaleOrder',
        formData: formData,
        getFormAPI: GetContractSaleOrder,
        getRequest: {
            id: id
        },
        updateFormAPI: UpsertContractSaleOrderAPI,
        updateKey: ContractSaleOrderKeys.UpsertContractSaleOrder,
        mode: id ? 'edit' : 'add'
    }));
};
export default NewContractSaleOrder;
